import React, { useEffect, useState } from 'react'
import lottie, { AnimationConfigWithPath, AnimationConfigWithData } from 'lottie-web'
import { PropsOf } from '@codeleap/types'
import { View } from '@/components'

export type AnimationsProps =
  PropsOf<typeof View> &
  {
    animation: AnimationConfigWithData<'svg'>['animationData']
    height?: number
    width?: number
    loop?: boolean
    animationProps?: AnimationConfigWithPath<'svg'> | AnimationConfigWithData<'svg'>
    autoplay?: boolean
  }

export const Animations = (props: AnimationsProps) => {
  const {
    animation,
    height,
    width,
    loop = true,
    autoplay = true,
    animationProps = {},
    ...containerProps
  } = props

  // Use a DOM-attached callback ref instead of forwarding through `<View>`:
  // under React 19 the lib's ref forwarding wasn't populating
  // animationContainerRef.current in time for `onMount`, so lottie was
  // initialising with `container: undefined` and silently rendering nothing.
  const [container, setContainer] = useState<HTMLDivElement | null>(null)

  // Boot the lottie animation once the inner div is mounted; destroy it on
  // unmount or when the animation/loop/autoplay inputs change.
  useEffect(() => {
    if (!container) return
    const _animation = lottie.loadAnimation({
      container,
      renderer: 'svg',
      loop,
      autoplay,
      animationData: animation,
      ...animationProps,
    })
    return () => _animation.destroy()
  }, [container, animation, loop, autoplay])

  return (
    <View {...containerProps}>
      <div ref={setContainer} style={{ width: '100%', height: '100%' }} />
    </View>
  )
}
